import { ReducerBase } from 'common/reducer';
import initialState from 'app/initialState';
import CommodityExchange from 'domain/commodityExchange';
import { ExchangesLoaded } from './exchanges.actions';

export class ExchangesReducer extends ReducerBase<CommodityExchange[]> {
	constructor() {
		super();
		this.addHandler(ExchangesLoaded.EventName, this.handleExchangesLoaded);
	}

	handleExchangesLoaded(state: CommodityExchange[] = initialState.exchanges, event: ExchangesLoaded): CommodityExchange[] {
		return event.exchanges;
	}

	handleDefault(state: CommodityExchange[] = initialState.exchanges) {
		return state;
	}
}
